/**
 * Get the API base URL
 * In production (HTTPS), use relative URLs
 * In development, use localhost
 */
export function getApiUrl(): string {
  // If explicitly set via env var, use that
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // In production (served over HTTPS), use relative URL
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '/api';
  }

  // Default to localhost for development
  return 'http://localhost:3001/api';
}

/**
 * Get the WebSocket URL
 * In production, use same origin with wss://
 * In development, use localhost
 */
export function getWsUrl(): string {
  // If explicitly set via env var, use that
  if (import.meta.env.VITE_WS_URL) {
    return import.meta.env.VITE_WS_URL;
  }

  // In production, use same origin with wss://
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return `wss://${window.location.host}`;
  }

  // Default to localhost for development
  return 'ws://localhost:3001';
}
